import Div from "@jumbo/shared/Div";
import {
  TabContext,
  TabList,
  TabPanel,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Typography,
} from "@mui/material";
import hrApiServices from "app/services/hr-api-services";
import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

const LeaveDocumentApproval = ({
  openViewRequest,
  setOpenViewRequest,
  value,
  handleChange,
  requests,
  approvalStatus,
  workflows = [],
  updateHistory,
}) => {
  const [status, setStatus] = useState();
  const [leaveBalance, setLeaveBalance] = useState([]);
  const [loadingBalance, setLoadingBalance] = useState(false);

  console.log("approvalStatus", status);
  const defaultStatus = approvalStatus;
  useEffect(() => {
    setStatus(defaultStatus);
  }, [approvalStatus, defaultStatus]);

  const getListofApplyLeaves = () => {
    setLoadingBalance(true);

    hrApiServices
      .listofLeaveTaken(
        requests?.Company_Id?.id || requests?.Company_Id, // 👈 company id from leave request
        requests?.Partner_Id?.id || requests?.Partner_Id, // 👈 partner id from leave request
        requests?.Employee_Id?.id || requests?.Employee_Id, // 👈 employee from leave request
        requests?.Year || new Date().getFullYear(), // 👈 year from leave request or current year as fallback,
      )
      .then((res) => {
        setLeaveBalance(res || []);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoadingBalance(false));
  };

  useEffect(() => {
    if (requests?.Employee_Id?.id) {
      getListofApplyLeaves();
    }
  }, [ requests]);

  return (
    <>
      <Dialog maxWidth="lg" fullWidth open={openViewRequest}>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}
        >
          <Div sx={{ fontSize: "18px" }}>View Leave Request</Div>
          <Div>
            <IconButton onClick={() => setOpenViewRequest(false)}>
              <MdClose />
            </IconButton>
          </Div>
        </DialogTitle>
        <DialogContent>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab
                  label="Overview"
                  value="1"
                  sx={{ fontSize: "16px", color: "#000000" }}
                />
              </TabList>
            </Box>

            <TabPanel value="1">
              <Div className="row">
                <Div className="col-md-10 card" sx={{ p: 1.5 }}>
                  <Typography variant="h5" fontWeight={600} mb={1}>
                    Leave Balance
                  </Typography>

                  {loadingBalance ? (
                    <Typography variant="h6">Loading...</Typography>
                  ) : leaveBalance?.length > 0 ? (
                    <Div className="row ms-1">
                      <Div className="col-md-3">
                        <Typography variant="h6" fontWeight={600}>
                          Leave Type
                        </Typography>
                      </Div>
                      <Div className="col-md-3">
                        <Typography variant="h6" fontWeight={600}>
                          Opening
                        </Typography>
                      </Div>
                      <Div className="col-md-3">
                        <Typography variant="h6" fontWeight={600}>
                          Taken
                        </Typography>
                      </Div>
                      <Div className="col-md-3">
                        <Typography variant="h6" fontWeight={600}>
                          Available
                        </Typography>
                      </Div>

                      {leaveBalance?.map((item, index) => (
                        <React.Fragment key={index}>
                          <Div className="col-md-3">
                            <Typography variant="h6">
                              {item.Leave_Type}
                            </Typography>
                          </Div>
                          <Div className="col-md-3">
                            <Typography variant="h6">
                              {item.Opening_Leaves}
                            </Typography>
                          </Div>
                          <Div className="col-md-3">
                            <Typography variant="h6">
                              {item.Taken_Leaves}
                            </Typography>
                          </Div>
                          <Div className="col-md-3">
                            <Typography
                              variant="h6"
                              sx={{
                                color:
                                  item.Available_Leaves <= 0
                                    ? "red"
                                    : "#3BD2A2",
                                fontWeight: 600,
                              }}
                            >
                              {item.Available_Leaves}
                            </Typography>
                          </Div>
                        </React.Fragment>
                      ))}
                    </Div>
                  ) : (
                    <Typography variant="h6">No leave balance found</Typography>
                  )}
                </Div>
              </Div>
              <br />


              <Div className="row">
                <Div className="col col-sm-2 col-md-3">
                  <Typography variant="h5">Leave Id</Typography>
                  <Typography variant="h5">Leave Type</Typography>
                  <Typography variant="h5">From Date</Typography>
                  <Typography variant="h5">To Date</Typography>
                  <Typography variant="h5">Reason Of Leave</Typography>
                </Div>
                <Div className="col col-sm-4 col-md-5">
                  <Typography variant="h5">
                    : {requests?.Application_Id}
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.Leavetype && requests?.Leavetype}
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.From_Date && requests?.From_Date}
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.To_Date && requests?.To_Date}
                  </Typography>
                  <Typography variant="h5">
                    : {requests?.ReasonOf_Leave && requests?.ReasonOf_Leave}
                  </Typography>
                </Div>
                <Div className="col-md-2" sx={{ mt: -2 }}>
                  {requests?.Approved_Flag === true &&
                  requests?.Status === true ? (
                    <img
                      src="./../../../../../images/StatusFlg/Approved.png"
                      width={150}
                      height={70}
                    />
                  ) : requests?.Approved_Flag === false &&
                    requests?.Status === true ? (
                    <div>
                      <img
                        src="./../../../../../images/StatusFlg/Rejected.png"
                        width={150}
                        height={70}
                      />
                    </div>
                  ) : (
                    <img
                      src="./../../../../../images/StatusFlg/Pending.png"
                      width={150}
                      height={70}
                    />
                  )}
                </Div>
              </Div>
            </TabPanel>
          </TabContext>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LeaveDocumentApproval;
